<script setup lang="ts">
import { useCodes } from '../../store/useCodes'
import { computed, watch } from 'vue'
import { useInventory } from '../../store/useInventory'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'

const props = defineProps<{
  task: any
  taskProperties: { [key: string]: any }
  inventoryItemSelection: any
}>()

const emit = defineEmits<{
  (e: 'update:inventoryItemSelection', data: any): void
}>()

/**only show if:
 * 1) combo task_type and selected rai code
 * 2) if rep has inv
 * 3) if qty_to_rep < 0
 * **/
const showInventoryItems = computed(() => {
  return (
    props.taskProperties &&
    props.taskProperties.rai_code &&
    props.task &&
    props.task.inventory_item_ids &&
    useCodes().isDeductionCode(props.taskProperties.rai_code) &&
    inventoryItemOptions.value.length &&
    useCodes().deductsFromRep(props.taskProperties.rai_code, String(props.task.task_type_id))
  )
})
const inventoryItemSelection = useModelWrapper(props, emit, 'inventoryItemSelection')
//Show items associated to task and in reps BOH
const inventoryItemOptions = computed(() => {
  return useInventory().getInventorySelectionItemsByTaskId(props.task.task_id)
})
//logic to select option
//todo: this may come from task property
const defaultSelectItem = () => {
  if (inventoryItemOptions.value.length) {
    inventoryItemSelection.value = inventoryItemOptions.value[0]
  } else {
    inventoryItemSelection.value = undefined
  }
}
//pick first option on init and update
defaultSelectItem()
watch(
  () => props.task.task_id,
  () => {
    defaultSelectItem()
  }
)
</script>
<template>
  <q-select
    filled
    v-if="showInventoryItems"
    v-model="inventoryItemSelection"
    :options="inventoryItemOptions"
    color="accent"
    label="Inventory Item Selection"
    behavior="menu"
  />
</template>
